import { Booking, BookingRequest, BookingService } from '@jooxter/api';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

const defaultOnError = (error: AxiosError) => {
  console.warn(error);
};

// Canonical versions of these mutations - previously duplicated in
// packages/core/src/mutations/booking.ts, which has been removed in favour of these so both
// @jooxter/core and @jooxter/bookings consumers share them.
export const useDeleteBookings = (
  onSuccess?: (data: Booking, variables: number[]) => void,
  onError?: (error: AxiosError) => void,
  onSettled?: () => void
) => {
  const mutationDelete = useMutation({
    mutationFn: (bookings: number[]) => {
      return BookingService.delete(bookings);
    },
    onSuccess,
    onError: onError ?? defaultOnError,
    onSettled,
  });

  return mutationDelete;
};

export const useUpdateBooking = (
  recurrence = false,
  onSuccess?: (data: Booking) => void,
  onError?: (error: AxiosError) => void,
  onSettled?: () => void
) => {
  const mutationUpdate = useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: BookingRequest }) => {
      if (recurrence) {
        return BookingService.updateWithRecurrence(id, payload);
      }

      // see https://jooxter.atlassian.net/browse/ND-5549
      // sending a rrule in the request body might recreate a recurrence even if not wanted
      return BookingService.update(id, { ...payload, rrule: undefined });
    },
    onSuccess,
    onError: onError ?? defaultOnError,
    onSettled,
  });

  return mutationUpdate;
};
